import axios from "axios";
import { ADMIN_URL, BASE_URL } from "../util/constants";
import User from "../interfaces/user";
import Medal from "../interfaces/medal";
import UserMedal from "../interfaces/userMedal";

const useApiAdmin = () => {
    const axiosInstance = axios.create({
        baseURL: BASE_URL,
    });

    const listUser = (token: string) => {
        return axiosInstance
            .get<User[]>(ADMIN_URL + "/users/" + token)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const editAdminUser = (token: string, userId: string, adminValue: boolean) => {
        return axiosInstance
            .put<User>(`${ADMIN_URL}/user/admin/${userId}/${token}`, {admin: adminValue})
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const createMedal = (token: string, medal: Medal) => {
        return axiosInstance
            .post<Medal>(`${ADMIN_URL}/medal/${token}`, medal)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const createUserMedal = (token: string, userId: string, medals: UserMedal[]) => {
        return axiosInstance
            .post<UserMedal[]>(`${ADMIN_URL}/medal/create/${userId}/${token}`, medals)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const handleError = (err: any) => {
        console.log("Error occurred: ", err);

        if(err.response) {
            console.log("Response: ", err.response.data);
            console.log("Status: ", err.response.status);
        } else if(err.request && err.config) {
            console.log("URL: ", err.config.baseURL);
            console.log("Method: ", err.config.method);
            console.log("URL requested: ", err.config.url);
        } else {
            console.log("Error message: ", err.message);
        }
    }

    return { listUser, editAdminUser, createMedal, createUserMedal };
}

export default useApiAdmin;